export type AppMode =
  | "marketing"
  | "church"
  | "platform";

function normalizeHost(
  value: string | undefined,
): string {
  return value?.trim().toLowerCase() ?? "";
}

function normalizeMode(
  value: string | undefined,
): AppMode | null {
  const normalized = value?.trim().toLowerCase();

  if (
    normalized === "marketing" ||
    normalized === "church" ||
    normalized === "platform"
  ) {
    return normalized;
  }

  return null;
}

export const DOMAINS = {
  marketing:
    normalizeHost(
      import.meta.env.VITE_MARKETING_HOST,
    ) || "getministryiq.com",

  church:
    normalizeHost(
      import.meta.env.VITE_CHURCH_HOST,
    ) || "ministryiq.app",

  platform:
    normalizeHost(
      import.meta.env.VITE_PLATFORM_HOST,
    ) || "platform.ministryiq.app",
} as const;

export const URLS = {
  marketing: `https://${DOMAINS.marketing}`,
  church: `https://${DOMAINS.church}`,
  platform: `https://${DOMAINS.platform}`,
} as const;

export const currentHost = normalizeHost(
  window.location.hostname,
);

const configuredMode = normalizeMode(
  import.meta.env.VITE_APP_MODE,
);

function resolveAppMode(): AppMode {
  if (
    currentHost === "localhost" ||
    currentHost === "127.0.0.1"
  ) {
    return configuredMode ?? "church";
  }

  if (
    currentHost === DOMAINS.marketing ||
    currentHost === `www.${DOMAINS.marketing}`
  ) {
    return "marketing";
  }

  if (currentHost === DOMAINS.platform) {
    return "platform";
  }

  if (
    currentHost === DOMAINS.church ||
    currentHost === `www.${DOMAINS.church}`
  ) {
    return "church";
  }

  // Render preview URL or unknown hostname.
  return configuredMode ?? "church";
}

export const appMode = resolveAppMode();

export const isMarketing =
  appMode === "marketing";

export const isChurch =
  appMode === "church";

export const isPlatform =
  appMode === "platform";